
/**
 * Created by Marcus Zhao on 8/27/2019.
 * Description:
 * calendar template for create /edit an calendar envents
 *
 * ------ maintenance history ------
 * 10/11/2019 Marcus Zhao  Add _loadEventValue() for edit event.
 * 10/30/2019 Marcus Zhao  change AllDay logc
 * 11/11/2019 Marcus Zhao  Add getPrivacyConfigruation for pluginevent mode
 * Updated by Daniel Wang on 8/29/2022 Replaced location with google map address to support map tile
 * 9/11/2022  Marcus Zhao  Add _loadEventValueFromAddin.
 * Updated by Daniel Wang on 10/25/2022 Don't show location tooltip on Ms-Addin
 *
 */
import { OnInit, Renderer2, Component, OnDestroy, ViewChild, HostListener, ElementRef, NgZone, ChangeDetectorRef } from '@angular/core';
import { CalendarDialogService } from './calendar-dialog.service';
import { Subject, ReplaySubject, Subscription, Observable } from 'rxjs';
import { CalendarDialogOpenOptions, CalendarDialogTriggerSource, CalendarDialogType, LocationExpand } from './calendar-dialog.model';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { ToastService } from '../../widgets/toast/toast.service';
import { EntryType } from '@tamalelibs/models/entry-type.model';
import { SET_NOTE_BODY_FOR_EDITING, NOTE_BODY_ENTER_EDITING } from '@tamalelibs/redux/template.actions';
import { filter, debounceTime, take, catchError } from 'rxjs/operators';
import { AppConfig } from '@tamalelibs/models/app-config.model';
import { TemplateService } from '@tamalelibs/services/template.service';
import { TemplateDialogService } from '../template/template-dialog.service';
import { NoteAttachmentsConfig, NoteAttachmentsAction, NoteAttachmentsActionTypes, NoteAttachmentsFeedbackTypes } from '../../components/note-attachments/note-attachments.model';
import { ArrayHelperService } from '@tamalelibs/services/array-helper.service';
import { NoteBodyAction } from '@tamalelibs/models/note-body-action.model';
import { AppState } from '../../redux';
import { Store } from '@ngrx/store';
import * as _lodash from 'lodash';
import { WebTemplateViewModel } from '../template/template-web.view-model';
import { PluginService } from '../../services/plugin.service';
import { NotificationStyles, NotificationOptions } from '../../widgets/notification/notification.model';
import { FormulaService } from '../../services/formula-service';
import { DELETE_AUTOSAVED_DRAFT, CREATE_EVENT_SUCCESS, CREATE_EVENT_FAILURE, UPDATE_EVENT_FAILURE, UPDATE_EVENT_SUCCESS } from '@tamalelibs/redux/note.actions';
import { NoteActions, StandardControlIds } from '@tamalelibs/constants/business.constants';
import { bizConstants } from '../../constants/biz.constants';
import { ContactService } from '@tamalelibs/services/contact.service';
import { OpenDynamicComponentService } from '../../pages/home/home-open-dynamic-component';
import { EntityBack } from '../entity-dialog/entity-dialog.model';
import { Contact } from '@tamalelibs/models/contact.model';
import { DateHelperService } from '@tamalelibs/services/date-helper.service';
import { businessConstants } from '@tamalelibs/constants/business.constants';
import { TemplateDialogBaseComponent } from '@tamalelibs/components/template-dialog.base.component';
import { ContactTemplateOpenOptions, ContactTemplateType } from '../../components/contact-dialog-new/contact-dialog.model';
import { MessageType } from '@tamalelibs/models/message.model';
import { MessageService } from '../../services/message.service';
import { EntryService } from '@tamalelibs/services/entry.service';
import { MapConfig } from '../tam-dashboard/tam-dashboard-map-tile/tam-dashboard-map/tam-dashboard-map.model';
import { EntityService } from '@tamalelibs/services/entity.service';
import { CalendarService } from '@tamalelibs/services/calendar.service';
import { OfficeAddIn } from '@tamalelibs/models/office-addin.model';
import { NoteDialogService } from '../note-dialog/note-dialog.service';
import { UUID } from 'angular2-uuid';
import { AddInType, AddInGlobalModel, AddInDepositType } from '../../models/addin.model';
import { AddInUtilities } from '../../services/utilities/addin-utilities';
import { HomeViewModel } from '../../pages/home/home-view.model';
import { WindowRef } from '../../services/window-ref';
import { getNoteSelector } from '@tamalelibs/redux/note.reducer';
import { StoreQuerierService } from '../../services/store-querier.service';
import { of as observableOf } from 'rxjs';
import { DuplicateEventService } from './duplicate-event/duplicate-event.service';
import { StringLiteralsPipe } from '../../pipes/translate.pipe';
import { MailBoxItemSource, MailBoxItemType } from '../note-dialog/note-dialog.model';

const threadList = 'thread-list';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'calendar-dialog',
    templateUrl: './calendar-dialog.component.html',
    styleUrls: ['./calendar-dialog.component.scss'],
    standalone: false
})
export class CalendarDialogComponent extends TemplateDialogBaseComponent implements OnInit, OnDestroy {

    @ViewChild('dialogRef', { static: true }) dialogRef;
    @ViewChild('entitylist', { static: false }) entitylist;
    @ViewChild('locationInput', { static: false }) locationEl;
    @ViewChild('eventType', { static: false }) eventTypeEl;

    addinSubject = '';
    addinSuccessTip = StringLiteralsPipe.translate('addin.event_successfully_created');
    allDay = false;
    dataItems: Array<any> = []; // suggestion items based on search, sub set of dataItems
    dateStartValue: Date;
    dateEndValue: Date;
    duplicateEvent: any;
    flyValue: string;
    hintContentStreet = '';
    isDialogHidden = false;
    isShowBtnClose = true;
    isOfficeAddinMode = false; // to support office add-in
    invliadContactList = [];
    isCheckbox = true;
    isNeedReload: boolean;
    inputEndTime = '0:00';
    inputStartTime = '0:00';
    isShowSearchAddress = false;
    isIncludeDuplicateEvent = false;
    isShowDuplicateEvents = false;
    isShowDuplicateTip = false;
    location = '';
    locationExpand: LocationExpand;
    locationShowInScreen = '';
    mapConfig = new MapConfig();
    noteAttachmentsConfig: NoteAttachmentsConfig;
    // calendar params
    selectParticipantItems: Array<any> = []; // addin participants items
    timeList: Array<string> = [];

    private _addinEntryId = '';
    private _currentAttachemtId: string;
    private _destroyFilterSubscriptions: Array<Subscription> = [];
    private _dialogOpenOptions: CalendarDialogOpenOptions;
    private _firstChangeStartTime = false;
    private _firstChangeEndTime = false;
    private _infoToast: NotificationOptions = {
        message: 'Saved to Draft',
        style: NotificationStyles.Info
    };
    private _lastStartTime: string;
    private _lastEndTime: string;
    private _notifyAction: any;
    private _noteTemplateConfigurations;
    private _officeAddInOld: OfficeAddIn; // store data when selecting an email and open it for the first time.
    private _participantSearchValue;

    constructor(
        private _calendarService: CalendarService,
        private _noteTemplatePageViewModel: WebTemplateViewModel,
        private _element: ElementRef,
        private _renderer: Renderer2,
        private _alertWindow: AlertWindowService,
        private _toast: ToastService,
        private _pluginService: PluginService,
        private _calendarDialogService: CalendarDialogService,
        private _templateService: TemplateService,
        private _templateDialogService: TemplateDialogService,
        private _formulaService: FormulaService,
        private _store: Store<AppState>,
        private _contactService: ContactService,
        private _openDynamicComponentService: OpenDynamicComponentService,
        private _dateHelperService: DateHelperService,
        private _messageService: MessageService,
        private _entryService: EntryService,
        private _entityService: EntityService,
        private _noteDialogService: NoteDialogService,
        private _zone: NgZone,
        private _changeDetectorRef: ChangeDetectorRef,
        private _homeViewModel: HomeViewModel,
        private _winRef: WindowRef,
        private _storeQuerier: StoreQuerierService,
        private _duplicateEventService: DuplicateEventService,
    ) {
        super();
        this._noteBodySubject = new Subject<NoteBodyAction>();
        this._el = this._element.nativeElement;
    }

    ngOnInit() {
        document.addEventListener('keydown', this.onDocumentEscape, true);
        this.noteAttachmentsConfig = new NoteAttachmentsConfig();
        this.noteAttachmentsConfig.dropzone = this.dialogRef._element;
        this.publishButtonHasBeenClicked = false;
        this.mapConfig.isFromMap = false;
        this._destroySubscriptions.push(
            this._calendarDialogService.dialogOpen$.subscribe((dialogOpenOptions: CalendarDialogOpenOptions) => {
                if (dialogOpenOptions.isOfficeAddinMode) {
                    this._initOfficeAddIn(dialogOpenOptions);
                    this.mapConfig.isShowInMSAddin = this.isOfficeAddinMode;

                }
                if (this._el.querySelector('.template-dialog') == null) { // Do not have a minimize dialog
                    this._dialogOpenOptions = dialogOpenOptions;
                    const startDate = dialogOpenOptions.startDate;
                    const endDate = dialogOpenOptions.endDate;
                    this.initEvent(startDate, endDate);
                    this.isPlugInEditNoteMode = dialogOpenOptions.isPluginInEditEventMode;
                    if (dialogOpenOptions.entryTypeId) {
                        this._createEntryId = dialogOpenOptions.entryTypeId;
                    }
                    if (this.isPlugInEditNoteMode) {
                        AppConfig.supportImgToStream = true;
                        this._pluginService.isPlugInEditNoteMode = this.isPlugInEditNoteMode;
                        this._setPluginEventEditPageStyle();
                    }
                    if (dialogOpenOptions.openType) {
                        this._teamplateMsgSubscriptions = this._noteTemplatePageViewModel.templateMsg().pipe(
                            filter(res => !!res)
                        ).subscribe(res => this._takeTemplateMsg(res));
                        this.titleName = dialogOpenOptions.openType;
                        this._noteAction = this._getNoteActionByOpenType(dialogOpenOptions.openType);

                        this.editingEntryId = dialogOpenOptions.entryId;
                        this._currentEntity = dialogOpenOptions.entity;

                        this._initData();
                        this._initAllType();
                        this.open();
                        setTimeout(() => {
                            if (this.editingEntryId) {
                                // dispatch get attachment action behind the scene
                                this._noteTemplatePageViewModel.getThreadAttachmentsById(this.editingEntryId);
                            } else {
                                this._onAttachmentLoaded(null, false);
                            }
                        }, 500);
                    }
                } else {
                    this.closemin();
                }
            }),
            this._calendarDialogService.dialogClose$.subscribe((dialogOpenOptions: any) => {
                this.close();
                this._clearData();
            })
        );
        this.initParticipantOntheFly();
        this._destroySubscriptions.push(
            this._noteTemplatePageViewModel.noteTypeForWeb().pipe(
                filter(res => res != null && res.entryTypes.length > 0 && res.defaultEntryTypeId.length > 0),
            ).subscribe(res => this._takeNoteType(res)),
            this._noteTemplatePageViewModel.noteForEdit().pipe(
                filter(res => res && res.id),
            ).subscribe(res => this._entry = res),
            this._noteTemplatePageViewModel.templateValueSet().subscribe((res) => this._templateValueSet = res),
            // best practice: if the selected data is directly bound to UI,
            // use map operator and bind the observable directly to UI using Angular async pipe
            this._noteTemplatePageViewModel.noteTemplateConfiguration().pipe(
                filter(res => res != null && res.contains != null && !!this._dialogOpenOptions),
            ).subscribe(res => {
                // this._processNoteTemplateConfiguration(res);
                if (!this.isOfficeAddinMode) {
                    this._processNoteTemplateConfiguration(res);
                } else {
                    // we need to store the latest note teamplateconfiguration each time when note type changes for office add-in
                    this._noteTemplateConfigurations = res;
                    if (this._firstOpen) {
                        // only need to get data from office when opening email for the first time
                        this._showAddInInfoOnNoteDialog(res);
                    } else {
                        this._processNoteTemplateConfiguration(res);
                    }
                }
            }),

            // gets if privacy enabled and privacySetting for combiling privacy teams list usage.
            this._noteTemplatePageViewModel.privacyConfiguration().pipe(
                filter(res => res != null && res.privacyEnabled != null),
            ).subscribe(res => this._takePrivacyConfiguration(res)),
            // gets privacy teams and default privcayid
            this._noteTemplatePageViewModel.privacyTeams().pipe(
                filter(res => res != null && res.privacyTeams != null),
            ).subscribe(res => this._takePrivacyTeams(res)),

            this._noteTemplatePageViewModel.attachments().pipe(
                filter(res => Object.keys(res) && Object.keys(res).length > 0 && !!this._dialogOpenOptions),
            ).subscribe(res => this._onAttachmentLoaded(res, false)),
            this.noteAttachmentsConfig.feedbackSubject$.subscribe((res) => {
                if (res && res.type === NoteAttachmentsFeedbackTypes.OnStatusChange) {
                    if (res.payload && res.payload.changedFile && res.payload.changedFile.ids && res.payload.changedFile.ids.length) {
                        if (res.payload.changedFile.isDirty) {
                            this._dirtyAttachments = this._dirtyAttachments.concat(res.payload.changedFile.ids);
                        } else {
                            this._dirtyAttachments = this._dirtyAttachments.filter((id) => !res.payload.changedFile.ids.includes(id));
                        }
                    }
                    if (res.payload && res.payload.workflow === 'upload') {
                        this.attachmentUploading = res.payload.isEditing;
                    }
                    if (res.payload && res.payload.workflow === 'rename') {
                        this.attachmentRenaming = res.payload.isEditing;
                    }

                }
            }),
            // note body html string subscription used in edit mode
            this._noteTemplatePageViewModel.noteBodyForEdit()
                .subscribe((res) => this._takeNoteBodyForEdit(res)),

            // prompt info dialog before closing the plugin note dialog when plugin token is expired
            this._pluginService.pluginSubject$.subscribe(() => {
                if (this.isPlugInEditNoteMode) {
                    const subscription = this._alertWindow.info('Your login session is expired.', ['Please click "OK" and try to deposit again.']).subscribe((result: boolean) => {
                        this._setDialogCloseForPlugin();
                        subscription.unsubscribe();
                    });
                }
            }),
            this._messageService.messageSubject$.subscribe(action => this._onMessageAction(action)),
        );
    }

    ngOnDestroy() {
        document.removeEventListener('keydown', this.onDocumentEscape, true);
        this._destroySubscriptions.forEach(item => item.unsubscribe());
        this._destroySubscriptions = [];
        this._destroyFilterSubscriptions.forEach(item => item.unsubscribe());
        this._destroyFilterSubscriptions = [];
        if (this._dropzoneSubscription$) {
            this._dropzoneSubscription$.unsubscribe();
        }
    }

    @HostListener('window:beforeunload', ['$event'])
    unloadNotification($event: any) {
        if (this.opened) {
            $event.returnValue = true;
        }
    }

    // Capture-phase document listener: fires before Kendo's bubble-phase esc handler.
    // Uses aria-expanded (logical state) rather than DOM visibility to detect open dropdowns —
    // aria-expanded is updated immediately when a popup starts closing, so it is immune to
    // the ~200ms close animation during which the popup DOM element is still present.
    onDocumentEscape = (event: KeyboardEvent) => {
        if (event.key !== 'Escape' && event.key !== 'Esc') { return; }
        if (!this.opened) { return; }
        // kendo-dropdownlist has aria-expanded on the host; kendo-multiselect and
        // kendo-datepicker expose it on their inner .k-input-inner <input> element.
        const hasOpenKendoPopup = !!document.querySelector(
            'kendo-dropdownlist[aria-expanded="true"], input.k-input-inner[aria-expanded="true"]'
        );
        if (hasOpenKendoPopup) { return; }
        // Check for open alert dialogs - let them handle ESC first
        const hasOpenAlertDialog = !!document.querySelector('.alert-window-container');
        if (hasOpenAlertDialog) { return; }
        // No open popup: stop propagation to prevent Kendo v19's clearAll() side-effect,
        // then trigger the unsaved-changes check.
        event.stopImmediatePropagation();
        this._zone.run(() => this.clickClose('close', null));
    };

    changeValueStreet(event) {
        this.isShowDuplicateTip = false;
        this.location = event;
        this.locationShowInScreen = this.location;
        this.locationExpand = new LocationExpand('', '', false, 0, 0);
    }

    clickSearchAddress() {
        this.isShowSearchAddress = !this.isShowSearchAddress;
        if (this.locationExpand && this.locationExpand.addressName && this.locationExpand.linkedEntityId) {
            this.mapConfig.inputValue = this._calendarService.getRealAddress(this.location);
        } else {
            this.mapConfig.inputValue = this.location;
        }
    }

    clickUpdateEvent(value) {
        this.editingEntryId = value;
        this.isShowDuplicateTip = false;
        this.publish(false);
    }

    /**
    *  user click the cancel/click  button
    *  status : tip alertWindow or close or others
    */
    clickClose(status: string, event: Event, isClosePanel = true) {
        if (!this._templateDialogService.changeValueStatus && this._dirtyAttachments.length === 0 && !this.attachmentUploading) {
            this._clearData();
            this._deleteDraftInPluginEditMode();
            this.close();
            if (isClosePanel) {
                AddInUtilities.closeTaskPaneForAddIn();
            }
        } else {
            const uploading = this._processingUploads.length && this._processingUploads.reduce((result, item) => result || item.status === 0, false);
            const warningText = 'Are you sure you want to ' + (uploading ? 'cancel file uploading and ' : '') + 'discard all your changes?';
            const subscription = this._alertWindow.warn('You have unsaved changes', [warningText]).subscribe((result: boolean) => {
                if (result) {
                    this._deleteDraftInPluginEditMode();
                    const action = new NoteAttachmentsAction();
                    action.type = NoteAttachmentsActionTypes.DeleteAttachments;
                    action.payload = {
                        workflow: 'cancel',
                        callback: (files) => {
                            this._clearData();
                            this.close();
                            if (isClosePanel) {
                                AddInUtilities.closeTaskPaneForAddIn();
                            }
                        }
                    };
                    this.noteAttachmentsConfig.actionSubject$.next(action);
                }
                subscription.unsubscribe();
            });
        }
        // make publish button work after close dialog
        this.publishButtonHasBeenClicked = false;
        if (event) {
            event.stopImmediatePropagation();
        }
    }

    /**
     * compare (startDate + startTime) with (endDate + endTime)
     * @param startDate
     * @param startTime
     * @param endDate
     * @param endTime
     */
    compareDate(startDate, startTime, endDate, endTime) {
        const _startDate = this._dateHelperService.getTimeStamp(startDate, startTime);
        const _endDate = this._dateHelperService.getTimeStamp(endDate, endTime);
        if (_startDate < _endDate) {
            return true;
        } else {
            return false;
        }
    }

    /**
    *  close task pane for office add-in
    */
    onCloseBtnClick() {
        AddInUtilities.closeTaskPaneForAddIn();
    }

    /**
     * create new contact by invalid paticipant.
     * set new contact to paticipant control.
     * @param item
     */
    clickInvalidContact(item) {
        if (AddInUtilities.isOfficeJSLoaded()) {
            let index;
            this._homeViewModel.increment();
            this._homeViewModel.getFlyIndex().pipe(take(1)).subscribe(res => index = res);
            const _contactDialogOpenOptions = new ContactTemplateOpenOptions();
            _contactDialogOpenOptions.openType = ContactTemplateType.NewContact;
            const contact = new Contact();
            const names = item.displayName.split(' ');
            contact.name = names[0];
            contact.lastName = names[1];
            contact.primaryEmail = item.emailAddress;
            contact.uuid = item.uuid;
            _contactDialogOpenOptions.contact = contact;
            _contactDialogOpenOptions.instanceId = index.toString();
            const entityBack = new EntityBack();
            entityBack.controlId = 'paticipant';
            _contactDialogOpenOptions.entityBack = entityBack;
            _contactDialogOpenOptions.isPaticipant = true;
            _contactDialogOpenOptions.isSource = true;
            this._noteDialogService.showAddInDialogBox(this, null, _contactDialogOpenOptions, this._callbackSetFlyEntity);
        }
    }

    /**
     * Paticipant on the fly; suppport addin and web.copy from ed-dropdown control
     */
    createContactOntheFly() {
        let index;
        this._homeViewModel.increment();
        this._homeViewModel.getFlyIndex().pipe(take(1)).subscribe(res => index = res);
        const _contactDialogOpenOptions = new ContactTemplateOpenOptions();
        _contactDialogOpenOptions.openType = ContactTemplateType.NewContact;
        const contact = new Contact();
        contact.name = this._participantSearchValue;
        _contactDialogOpenOptions.contact = contact;
        _contactDialogOpenOptions.instanceId = index.toString();
        const entityBack = new EntityBack();
        entityBack.controlId = 'participant';
        entityBack.searchValue = this._participantSearchValue;
        _contactDialogOpenOptions.entityBack = entityBack;
        _contactDialogOpenOptions.isFly = true;

        // we only need to show dialog box when user input entity/contact in taskpane for office add-in, so add index === 1 to determine the case.
        if (AddInUtilities.isOfficeJSLoaded() && index === 1) {
            this._noteDialogService.showAddInDialogBox(this, null, _contactDialogOpenOptions, this.callbackSetFlyEntity);
        } else {
            this._openDynamicComponentService.openContactDialog$.next(_contactDialogOpenOptions);
        }
    }

    callbackSetFlyEntity(self: any, entityList: any) {
        if (entityList) {
            self.flyValue = '';
            const item = self._entityService.mapEntityBriefList(entityList)[0];
            if (item) {
                self.selectParticipantItems.push(item);
            }

        }
    }

    /**
     * close dialog min
     */
    closemin() {
        this.maxmize();
        this.clickClose('close', null);
    }

    dateStartChange() {
        this._templateDialogService.changeValueStatus = true;
        this.isShowDuplicateTip = false;
        this.dateEndValue = _lodash.cloneDeep(this.dateStartValue);
    }

    dateEndChange() {
        this._templateDialogService.changeValueStatus = true;
        this.isShowDuplicateTip = false;
        const isValid = this.compareDate(this.dateStartValue, this.inputStartTime, this.dateEndValue, this.inputEndTime);
        if (!isValid) {
            const nextDate = new Date(this.dateEndValue.getTime() + 24 * 60 * 60 * 1000);
            this.dateEndValue = nextDate;
        }
    }

    /**
   * time startBlur for trigger timeStartClick
   * @param value
   */
    startTimeBlur(value) {
        if (this._dateHelperService.judgeTimeFormat(value)) {
            this.timeStartClick(value);
        } else {
            this.initTime();
        }
    }

    /**
     * input  endTime  for trigger timeEndClick
     * @param value
     */
    endTimeBlur(value) {
        if (this._dateHelperService.judgeTimeFormat(value)) {
            this.timeEndClick(value);
        } else {
            this.initTime();
        }
    }

    handleFilter(value) {
        this._noteTypes = [];
        if (!value) {
            this._noteTypes = this._noteTypesSource;
        } else {
            this._noteTypes = this._noteTypesSource.filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
        }
    }

    /**
     * Initialize the controls(date,time,participant) to the calendar event
     */
    initEvent(startDate, endDate) {
        let date;
        if (startDate && endDate) {
            this.dateStartValue = startDate;
            this.dateEndValue = endDate;
        } else {
            date = new Date();
            this.dateStartValue = date;
            this.dateEndValue = date;
        }
        this.initTime(startDate, endDate);
        this._destroyFilterSubscriptions.push(
            this._filterHandler$.pipe(
                debounceTime(250),
                filter(filterStr => filterStr != null && filterStr.length > 0)
            ).subscribe(filterStr => this._searching(filterStr))
        );
    }

    initParticipantOntheFly() {
        this._destroySubscriptions.push(
            this._openDynamicComponentService.feedbackSubject$.subscribe((feedback: EntityBack) => {
                if (feedback.controlId === 'participant') {
                    const contact = new Contact();
                    contact.id = feedback.entityId;
                    contact.name = feedback.searchValue;
                    this.selectParticipantItems.push(contact);
                    this._templateDialogService.changeValueStatus = true;
                }
            })
        );
    }

    inputStartDateBlur() {
        const min: Date = new Date(1900, 1, 1);
        setTimeout(() => {
            if (this.dateStartValue == null || this.dateStartValue.getTime() < min.getTime()) {
                this.dateStartValue = new Date();
                this.dateEndValue = new Date();
            }
        }, 0);
    }

    inputEndDateBlur() {
        setTimeout(() => {
            if (this.dateEndValue == null || this.dateEndValue.getTime() < this.dateStartValue.getTime()) {
                this.dateEndValue = new Date();
            }
        }, 0);
    }

    initDataItems(contactList) {
        this.dataItems = this._contactService.mapContactList(contactList).contacts;
        this.flyValue = this._entryService.isShowOnTheFly(this._participantSearchValue, this.dataItems);
    }

    initTime(startDate?: Date, endDate?: Date) {
        if (startDate && endDate) {
            // the date from calendar
            this.inputStartTime = this._convertTimeNuberToString(startDate.getHours()) + ':' + this._convertTimeNuberToString(startDate.getMinutes());
            this.inputEndTime = this._convertTimeNuberToString(endDate.getHours()) + ':' + this._convertTimeNuberToString(endDate.getMinutes());
        } else {
            // the date from current date
            const now = new Date();
            if (now.getMinutes() <= 30) {
                this.inputStartTime = now.getHours().toString() + ':30';
                this.inputEndTime = (now.getHours() + 1).toString() + ':00';
            } else {
                if (now.getHours() >= 23) {
                    this.inputStartTime = '0:00';
                    this.inputEndTime = '0:30';
                    this.dateStartValue = new Date(now.getTime() + 24 * 60 * 60 * 1000);
                    this.dateEndValue = new Date(now.getTime() + 24 * 60 * 60 * 1000);
                } else {
                    this.inputStartTime = (now.getHours() + 1).toString() + ':00';
                    this.inputEndTime = (now.getHours() + 1).toString() + ':30';
                }
            }
        }
    }

    keySend(event) {
        if (event.ctrlKey && event.keyCode === 13) {
            this.publish();
        }
    }

    locationChange(value) {
        this._templateDialogService.changeValueStatus = true;
    }

    /**
     * dialog maxmize
     */
    maxmize() {
        this._renderer.setStyle(this._el.querySelector('.minimize-interface'), 'visibility', 'hidden');
        this._renderer.setStyle(this._el.querySelector('.template-dialog'), 'visibility', 'visible');
        this._calendarDialogService.minimized = false;
    }

    onOpen(event: any): void {
        const inputValue = this.entitylist.wrapper.nativeElement.querySelector('input', '.k-multiselect-wrap .k-floatwrap').value;
        if (!inputValue) {
            event.preventDefault();
        }
    }

    /**
     * open a default browser to show entry detail
     */
    onSubjectClick() {
        if (AddInUtilities.isOfficeEnvironment()) {
            const win = this._winRef.nativeWindow;
            if (win && win.location.href && this._addinEntryId) {
                const noteLink = win.location.origin + '/tamaleweb/entry/' + this._addinEntryId;
                // open a default web browser, not a browser embedded in office
                if (Office.context.ui.openBrowserWindow) {
                    // app email
                    Office.context.ui.openBrowserWindow(noteLink);
                } else {
                    // web email
                    window.open(noteLink, '_blank');
                }
            }
        }
    }

    onClickReload() {
        const calenarDialogOpenOptions = _lodash.cloneDeep(this._dialogOpenOptions);
        // only edit event has entryId.
        if (this._entry && this._entry.id && this._dialogOpenOptions.openType === CalendarDialogType.EditEvent) {
            calenarDialogOpenOptions.entryId = _lodash.cloneDeep(this._entry.id);
        }
        calenarDialogOpenOptions.entryTypeId = this._notifyAction.payload.id;
        calenarDialogOpenOptions.minimizable = true;
        this.opened = false;
        this._clearData();
        this._noteAction = null;
        setTimeout(() => {
            this._calendarDialogService.dialogOpen$.next(calenarDialogOpenOptions);
        }, 0);
    }

    /**
     * checkbox allDay
     */
    oncheckedChange() {
        this._templateDialogService.changeValueStatus = true;
        this.isShowDuplicateTip = false;
        if (!this.allDay) {
            this.inputStartTime = this._lastStartTime;
            this.inputEndTime = this._lastEndTime;
        } else {
            this._lastStartTime = this.inputStartTime;
            this._lastEndTime = this.inputEndTime;
            this.inputStartTime = '00:00';
            this.inputEndTime = '00:00';
        }
    }

    onEndTimeChange(value: any) {
        if (!this._firstChangeEndTime) {
            this._firstChangeEndTime = true;
        } else {
            this._templateDialogService.changeValueStatus = true;
        }
        this.inputEndTime = value;
    }

    onStartTimeChange(value: any) {
        if (!this._firstChangeStartTime) {
            this._firstChangeStartTime = true;
        } else {
            this._templateDialogService.changeValueStatus = true;
        }
        this.inputStartTime = value;
    }

    /**
     * dialog open
     */
    open() {
        // Add class "threaddetail-sidesheet-status" to display side sheet when open note dialog
        if (this._el.querySelector('.calendar_dialog')) {
            if (!this._el.querySelector('.threaddetail-sidesheet-status')) {
                this._renderer.addClass(this._el.querySelector('.calendar_dialog'), 'threaddetail-sidesheet-status');
            }
        }
        this.opened = true;
        this._calendarDialogService.opened = true;
        this._calendarDialogService.openedAddin = true;
    }

    /**
     *
     */
    onEnter(value) {
        if (this.opened) {
            this.clickClose('close', null);
        }
    }

    onCancelBtnClick(event: Event) {
        this.clickClose('cancel', event);
        // make button work after click cancle button
        this.publishButtonHasBeenClicked = false;
    }

    onClickViewDuplicateEvent() {
        this._duplicateEventService.dialogOpen$.next({ data: this.duplicateEvent, currentType: this._noteTypeDefalult });
    }

    privacyChanged(data) {
        this._privacyTeam = data;
    }

    privacyHandleFilter(value) {
        this._privacyList = this._privacyListSource.filter((s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1);
    }
    /**
     * find participants list
     * @param value
     */
    participantsFilter(value) {
        this.entitylist.toggle(false);
        this._filterHandler$.next(value);
        this._participantSearchValue = value;

    }

    publish(isNeedCheckDuplicate: boolean = false) {
        this.publishButtonHasBeenClicked = true;
        this._saveAction = NoteActions.saveNote;
        this._preSaveNote(false, false, isNeedCheckDuplicate);
        this._publishSubject$.next('');
    }

    selectionChange(value: any): void {
        this.accumulateTemplateValueSetChanges(); // save the previous template when switching note types
        this._noteTypeChanged(value.id);
        this.isNeedReload = false;
    }

    /**
     * set selected address for event
     * @param event
     */
    setSelectedAddress(event) {
        if (event.payload) {
            // including entity and contact
            if (event.payload.mapContactModel.contact) {
                const contact: Contact = event.payload.mapContactModel.contact;
                const entityIndex = event.payload.mapContactModel.entityIndex;
                if (entityIndex > -1) {
                    this.location = event.payload.mapContactModel.selectedAddress;
                    this.locationShowInScreen = this._calendarService.generateDisplayLocation(contact.name, event.payload.mapContactModel.selectedAddressType, event.payload.mapContactModel.selectedAddress);
                    if (event.payload.mapContactModel.latitude !== 0 || event.payload.mapContactModel.longitude !== 0) {
                        this.locationExpand = new LocationExpand(contact.id, event.payload.mapContactModel.selectedAddressType, true, event.payload.mapContactModel.latitude, event.payload.mapContactModel.longitude);
                    } else {
                        this.locationExpand = new LocationExpand(contact.id, event.payload.mapContactModel.selectedAddressType, false, event.payload.mapContactModel.latitude, event.payload.mapContactModel.longitude);
                    }
                }
            } else {
                // Returns a structured address from the server
                const googleAddress = event.payload.mapContactModel.selectedAddress;
                this._entityService.getAddress(googleAddress).pipe(
                    take(1),
                ).subscribe(() => {
                    this.location = event.payload.mapContactModel.selectedAddress;
                    this.locationShowInScreen = this.location;
                    this.locationExpand = new LocationExpand('', '', false, 0, 0);
                });
            }
        }
        this.isShowSearchAddress = false;
    }

    /**
     * @param value
     */
    timeEndClick(value) {
        this.isShowDuplicateTip = false;
        this.inputEndTime = value;
        const isValid = this.compareDate(this.dateStartValue, this.inputStartTime, this.dateEndValue, value);
        if (!isValid) {
            const nextDate = new Date(this.dateEndValue.getTime() + 24 * 60 * 60 * 1000);
            this.dateEndValue = nextDate;
        }
    }

    /**
     * Depending on the start time, the finish time will be added 30 minutes
     * @param value
     */
    timeStartClick(value) {
        this.isShowDuplicateTip = false;
        this.inputStartTime = value;
        const timpStampValue = this._dateHelperService.getTimeStamp(this.dateStartValue, value);
        const timeEnd = new Date(timpStampValue + 30 * 60 * 1000);
        this.inputEndTime = timeEnd.getHours().toString() + ':' + (timeEnd.getMinutes() > 10 ? timeEnd.getMinutes().toString() : '0' + timeEnd.getMinutes().toString());
        const isValid = this.compareDate(this.dateStartValue, this.inputStartTime, this.dateEndValue, this.inputEndTime);
        if (!isValid) {
            const nextDate = new Date(this.dateEndValue.getTime() + 24 * 60 * 60 * 1000);
            this.dateEndValue = nextDate;
        }
    }

    valueChangeForParticipant(value) {
        this.isShowDuplicateTip = false;
        this._templateDialogService.changeValueStatus = true;
    }

    /**
    * click the  minimize button .appear the minimize window
    */
    windowMinimize() {
        this._renderer.setStyle(this._el.querySelector('.minimize-interface'), 'visibility', 'visible');
        // this.isShow = true;
        this._renderer.setStyle(this._el.querySelector('.template-dialog'), 'visibility', 'hidden');
        this._calendarDialogService.minimized = true;

    }

    // call back from dialog box.
    private _callbackSetFlyEntity(self: any, entityBack: EntityBack) {
        const contact = new Contact();
        contact.id = entityBack.entityId;
        contact.name = entityBack.searchValue;
        self._zone.run(() => {
            self.selectParticipantItems.push(contact);
            self._templateDialogService.changeValueStatus = true;
            if (entityBack['uuid']) {
                self.invliadContactList = self.invliadContactList.filter(item => item.uuid !== entityBack['uuid']);
            }
        });
    }

    private _convertTimeNuberToString(num: number): string {
        if (num === 0) {
            return '00';
        } else {
            return num.toString();
        }
    }

    private _clearData() {
        this._noteTypes = null;
        this._noteTypesSource = null;
        this._noteTypeDefalult = null;
        this.privacyListDefalult = null;
        this._privacyList = null;
        this._firstOpen = true;
        this._previousTemplateValueSet = {};
        this._createEntryId = null;
        this._dialogOpenOptions = null;
        this._templateDialogService.changeValueStatus = false;
        this._dirtyAttachments = [];
        this.isPrivacy = false;
        this.selectParticipantItems = [];
        this.location = '';
        this.locationShowInScreen = '';
        this.dateStartValue = null;
        this.dateEndValue = null;
        this.allDay = false;
        this._firstChangeStartTime = false;
        this._firstChangeEndTime = false;
        this.isShowEventArea = false;
        this.isNeedReload = false;
        this._entry = null;
        this._noteTemplateConfigurations = null;
        this._noteTemplatePageViewModel.cleanEntryTemplate();
    }

    private close() {
        // when close the dialog, the publish button will work
        this.publishButtonHasBeenClicked = false;
        if (!this.isPlugInEditNoteMode) {
            if (this._dropzoneSubscription$) {
                this._dropzoneSubscription$.unsubscribe();
            }
            if (this._teamplateMsgSubscriptions) {
                this._teamplateMsgSubscriptions.unsubscribe();
            }
            this.opened = false;
            // when switching from calendar dialog to note dialog, we don't want to show either the note dialog info section or the success info section
            this.isDialogHidden = false;
            this._calendarDialogService.opened = false;
            this._calendarDialogService.minimized = false;
        } else {
            this._setDialogCloseForPlugin();
        }
        this._destroyFilterSubscriptions.forEach(item => item.unsubscribe());
        this._destroyFilterSubscriptions = [];

        this.isShowSearchAddress = false;
    }

    private _createNoteInitialization() {
        this._noteTemplatePageViewModel.getNoteTypes('', 'event');
        this._noteTemplatePageViewModel.getPrivacyConfiguration(AppConfig.privacyConfiguration);
    }

    private _deleteDraftInPluginEditMode() {
        if (this.isPlugInEditNoteMode) {
            this._store.dispatch({
                type: DELETE_AUTOSAVED_DRAFT,
                payload: {
                    id: this.editingEntryId,
                    componentId: 'Note Dialog',
                    draft: true,
                }
            });
        }
    }

    private _editNoteInitialization() {
        this._noteTemplatePageViewModel.getNoteTypes(this.editingEntryId);
        this._noteBodyOnEdit();
        // only plugin need init privacy.
        if (this.isPlugInEditNoteMode) {
            this._noteTemplatePageViewModel.getPrivacyConfiguration(AppConfig.privacyConfiguration);
        }
    }

    private _getNoteActionByOpenType(openType: string) {
        switch (openType) {
            case CalendarDialogType.NewEvent:
                return NoteActions.createNote;
            case CalendarDialogType.EditEvent:
                return NoteActions.editNote;
            default:
                return NoteActions.createNote;
        }
    }

    private _initData() {
        this.dialogWidth = 684;
        this.domainUrl = window.location.host;
        this._noteTypesSource = new Array<EntryType>();
        this._noteTypeDefalult = new EntryType();
        this.privacyListDefalult = new Array<any>();
        this._privacyList = new Array<any>();
        this._tplConfig = [];
    }

    /**
     * Initialization based on different actions
     */
    private _initAllType() {
        switch (this._noteAction) {
            case NoteActions.createNote:
                this._createNoteInitialization();
                break;
            case NoteActions.editNote:
                if (this.editingEntryId != null && this.editingEntryId.length > 0) {
                    this._editNoteInitialization();
                }
                break;
            default:
                break;
        }
    }

    private _initDefaultNoteType(res) {
        const data = res.entryTypes;
        this._noteTypeDefalult = new EntryType();
        // if edit event but this event type is no-exist in event type list or set hide in note model。
        if (res.defaultEntryTypeId && res.defaultEntryTypeName) {
            this._noteTypeDefalult.id = res.defaultEntryTypeId;
            this._noteTypeDefalult.name = res.defaultEntryTypeName;
            this._noteTypeChanged(this._noteTypeId);
        } else {
            // exsit event type in list (new or edit event)
            for (const index in data) {
                if (data[index].id.toString() === this._noteTypeId) {
                    this._noteTypeDefalult.id = data[index].id;
                    this._noteTypeDefalult.name = data[index].name;
                    this._noteTypeChanged(this._noteTypeId);
                    break;
                }
            }
        }
    }

    private _initLocationExpand(locationExpand: string) {
        if (this._noteAction === NoteActions.editNote) {
            if (locationExpand) {
                this.locationExpand = JSON.parse(locationExpand);
            }
        }
        this.isShowSearchAddress = false;

    }

    /**
     * get duplicate events
     * if no data,will publish directly.
     */
    private _isDuplicateEvent(startTime, endTime, subject) {
        this._contactService.checkDuplicateEvent(
            startTime, endTime,
            subject).pipe(
                take(1),
                catchError((error) => {
                    return observableOf(null);
                }),
            ).subscribe(res => {
                if (res && res.count === 0) {
                    this.publish();
                } else {
                    const entryList = [];
                    this.isShowDuplicateTip = true;
                    const eventThreadList = res[threadList];
                    this.duplicateEvent = this._calendarService.mapToCalendarEventList(eventThreadList);
                }
            });
    }

    /**
    * init some status and set value.
    * @param dialogOpenOptions
    */
    private _initOfficeAddIn(dialogOpenOptions: CalendarDialogOpenOptions) {
        this.isOfficeAddinMode = dialogOpenOptions.isOfficeAddinMode;
        this._officeAddIn = dialogOpenOptions.officeAddIn;
        this._firstOpen = true;
        this.editingEntryId = '';
        this.isDialogHidden = false;
        this.isSingleTemplate = true;
        this.publishButtonHasBeenClicked = false;
        this._setPluginEventEditPageStyle();
        if (Office.context.mailbox.item.optionalAttendees &&
            Office.context.mailbox.item.requiredAttendees) {
            this._destroySubscriptions.push(
                this._contactService.checkContactFromEmail().subscribe(res => {
                    this.invliadContactList = res.filter(item => !item.tamaleContact);
                    // set invalid paticipant value.
                    this.invliadContactList.forEach((item, index) => {
                        item['uuid'] = UUID.UUID();

                        item.displayName = item.displayName.replace(',', '');
                    });
                    // set paticipant value.
                    res.forEach(item => {
                        if (item.tamaleContact) {
                            const data = {
                                id: item.tamaleContact.id,
                                name: item.tamaleContact.name,
                            };
                            this.selectParticipantItems.push(data);
                        }
                    });
                }));
        }
    }

    /**
     * load event date from mailbox.
     *
     */
    private _loadEventValueFromAddin() {
        if (this._dialogOpenOptions.isOfficeAddinMode) {
            this.location = Office.context.mailbox.item.location;
            this.locationShowInScreen = this.location;
            if (Office.context.mailbox.item.end && Office.context.mailbox.item.start) {
                this.dateEndValue = Office.context.mailbox.item.end;
                this.dateStartValue = Office.context.mailbox.item.start;
                this.allDay = Office.context.mailbox.item['isAllDayEvent'] || false;
                this.inputStartTime = this.dateStartValue.getHours() + ':' + this.dateStartValue.getMinutes().toString().padStart(2, '0');
                this.inputEndTime = this.dateEndValue.getHours() + ':' + this.dateEndValue.getMinutes().toString().padStart(2, '0');
            }
        }
    }

    /**
     * loading event value
     */
    private _loadEventValue() {
        // Location
        this.location = this._entry[businessConstants.calendar.ownProperties.locationId];
        // locationExpand
        const locationExpand = this._entry[businessConstants.calendar.ownProperties.locationExpandId];
        if (locationExpand) {
            this._initLocationExpand(locationExpand.value);
        }
        this.locationShowInScreen = this._calendarService.getDisplayLocationByLocationExpand(this.location, locationExpand);
        const participants = [];
        let entryAttendes = [];
        entryAttendes = this._entry[businessConstants.calendar.ownProperties.attendeesId];
        if (entryAttendes && entryAttendes.length > 0) {
            this._entry[businessConstants.calendar.ownProperties.attendeesId].forEach(item => {
                const contact = new Contact();
                contact.id = item['id'];
                contact.name = item['short-name'];
                participants.push(contact);
            });
        }
        this.selectParticipantItems = participants;
        // if check the all checkbox, outlook return 'False' web return 'False' richClient didn't return the data
        if (!this._entry[businessConstants.calendar.ownProperties.allDayId] ||
            this._entry[businessConstants.calendar.ownProperties.allDayId] === 'false' ||
            this._entry[businessConstants.calendar.ownProperties.allDayId] === 'False') {
            this.allDay = false;
        } else {
            this.allDay = true;
        }
        this.dateEndValue = new Date(parseInt(this._entry[businessConstants.calendar.ownProperties.endDateId], 0));
        this.dateStartValue = new Date(parseInt(this._entry['displaydate'], 0));
        this.inputStartTime = this.dateStartValue.getHours() + ':' + this.dateStartValue.getMinutes().toString().padStart(2, '0');
        this.inputEndTime = this.dateEndValue.getHours() + ':' + this.dateEndValue.getMinutes().toString().padStart(2, '0');
    }

    private _noteTypeChanged(id) {
        this._noteTypeId = id.toString();
        this._noteTemplatePageViewModel.getNoteTemplateConfiguration(id);
    }

    private _noteBodyOnEdit() {
        this._noteBodySubject.next({ type: NOTE_BODY_ENTER_EDITING });
    }

    /**
       * recive server notification and reopen entity dialog.
       * @param action
       */
    private _onMessageAction(action) {
        if (action.type === MessageType.ENTRY_TEMPLATE && action.payload.id === this._noteTypeId && this.opened) {
            this._notifyAction = action;
            this.isNeedReload = true;
        }
    }

    private _onAttachmentLoaded(res, isBlastEmail, isAddIn?: boolean, isRefresh = false) {

        const action = new NoteAttachmentsAction();
        action.type = NoteAttachmentsActionTypes.SetAttachments;
        if (!isAddIn) {
            action.payload = { response: res, noteAction: this._noteAction, isBlastEmail: isBlastEmail, additionalFiles: this._dialogOpenOptions ? this._dialogOpenOptions.attachments : [] };
        } else {
            action.payload = { response: res, noteAction: NoteActions.createNote, isOfficeAddin: true, additionalFiles: [], isRefresh };
        }
        this.noteAttachmentsConfig.actionSubject$.next(action);
    }

    private _processNoteTemplateConfiguration(config: any) {
        this._widthFactor = 1.2;
        const target = _lodash.cloneDeep(config);
        if (this.isPlugInEditNoteMode) {
            this.dialogWidthForPlugin = Math.floor(target.width * this._widthFactor) + 80;
            this.dialogWidth = this.dialogWidthForPlugin;
        } else {
            // workaround for suitable event dialog
            const windowWidth = window.innerWidth - 120 - 64 - 100;
            if (config.width * this._widthFactor > windowWidth) {
                this._widthFactor = windowWidth / config.width;
            }
            this.dialogWidth = Math.floor(target.width * this._widthFactor) + 80;
        }

        this._noteTemplatePageViewModel.cleanTemplateValueSet();
        this.valueChangeSubject = new ReplaySubject<any>(10);
        this._destroySubscriptions.push(
            this.valueChangeSubject.subscribe(res => this.isShowDuplicateTip = false));

        switch (this._noteAction) {
            case NoteActions.createNote:
                if (this._firstOpen) {
                    this._firstOpen = false;
                    this._loadEventValueFromAddin();
                    Array.from(this.setStaticDefaultValueForCreate(this.processingDataFromJson(target.contains)));
                    return;
                } else {
                    Array.from(this.setStaticDefaultValueForNoteTypeSwitching(this.processingDataFromJson(target.contains), true));
                    return;
                }
            case NoteActions.editNote:
            case NoteActions.createSidenote:
            case NoteActions.editSidenote:
                if (this.editingEntryId && this.editingEntryId.length > 0) {
                    if (this._firstOpen) {
                        this._firstOpen = false;
                        if (this._noteAction === NoteActions.editNote || this._noteAction === NoteActions.editSidenote) {
                            this._noteTemplatePageViewModel.getNoteBodyForEdit(this.editingEntryId);
                        } else if (this._noteAction === NoteActions.createSidenote) {
                            this._entry.priority = 0;
                            this._entry.sentiment = 0;
                            this._entry.source = null;
                        }
                        this._loadEventValue();
                        Array.from(this.setStaticDefaultValueForEdit(this.processingDataFromJson(target.contains)));
                        this._setCusor();
                        return;
                    } else {
                        Array.from(this.setStaticDefaultValueForNoteTypeSwitching(this.processingDataFromJson(target.contains), true));
                        this._setCusor();
                        return;
                    }
                } else {
                    return config.contains;
                }
            default:
                return config.contains;
        }
    }

    private _preSaveNote(draftFlag: boolean, auto: boolean = false, isNeedCheckDuplicate: boolean = false) {
        let valueSet = _lodash.cloneDeep(this._templateValueSet);
        valueSet = this._templateService.processStandardFields(valueSet);
        valueSet = this._templateService.processSaveActionsForWeb(valueSet, this._privacyTeam, false, null);

        const emptyFields = this._templateService.checkRequiredFields(valueSet, draftFlag);
        if (emptyFields.length > 0) {
            let msg = '';
            const msgArr = [];
            // if the alert window show, the button will work
            this.publishButtonHasBeenClicked = false;
            for (let emptyField of emptyFields) {
                emptyField = emptyField.trim();
                if (emptyField.lastIndexOf(':') === emptyField.length - 1) {
                    emptyField = emptyField.substring(0, emptyField.length - 1);
                }
                msgArr.push(emptyField);
                msg = msgArr.join(',');
            }
            const subscription = this._alertWindow.error('Required data',
                ['Please enter the information for the required fields:', msg]).subscribe((result: boolean) => {
                    subscription.unsubscribe();
                });
        } else if (this._noteAction === NoteActions.editNote || this._noteAction === NoteActions.createSidenote || this._noteAction === NoteActions.editSidenote) {
            // if it is creating sidenote, validate if the entities have been changed
            this._validateEntityChangesForSidenote(valueSet, draftFlag, auto);
        } else {
            if (this.isOfficeAddinMode && isNeedCheckDuplicate) {
                this.publishButtonHasBeenClicked = false;
                const subject = valueSet[bizConstants.standardControlID.subject].value;
                const sendSTime = this._dateHelperService.getTimeStamp(this.dateStartValue, this.inputStartTime);
                const sendETime = this._dateHelperService.getTimeStamp(this.dateEndValue, this.inputEndTime);
                this._isDuplicateEvent(sendSTime, sendETime, subject);
            } else {
                this._saveNote(valueSet, draftFlag, auto);
            }
        }
    }

    private _searching(filStr: string) {
        this.entitylist.loading = true;
        this._destroySubscriptions.push(this._contactService.getSourceList(1, 50, filStr)
            .subscribe(
                res => {
                    this.entitylist.loading = false;
                    this.entitylist.toggle(true);
                    this.initDataItems(res);
                }));
    }

    private _saveNote(valueSet, draftFlag: boolean, auto: boolean = false) {
        valueSet = this._templateService.appendPrivacyTeamToEntitiesForWeb(valueSet, this._privacyTeam);
        const subject = this._formulaService.handleSubjectByFormula(valueSet);
        if (subject !== null && subject !== undefined && subject !== '') {
            valueSet[bizConstants.standardControlID.subject].value = subject;
        }
        const sendSTime = this._dateHelperService.getTimeStamp(this.dateStartValue, this.inputStartTime);
        const sendETime = this._dateHelperService.getTimeStamp(this.dateEndValue, this.inputEndTime);
        if (sendSTime > sendETime) {
            const subscription = this._alertWindow.error('DateError',
                ['date is invalid']).subscribe((result: boolean) => {
                    subscription.unsubscribe();
                });
        }
        let noteBody = '';
        noteBody = this._templateService.createNoteBodyHtml(valueSet);
        const selectParticipantIds: Array<string> = [];
        this.selectParticipantItems.forEach(item => {
            selectParticipantIds.push(item.id);
        });

        const action = new NoteAttachmentsAction();
        action.type = NoteAttachmentsActionTypes.DeleteAttachments;
        action.payload = {
            workflow: 'save',
            callback: (files) => {
                const formData = {
                    body: noteBody,
                    keepdoc: false,
                    entryclass: 'event',
                    start: sendSTime,
                    end: sendETime,
                    location: this.location,
                    participants: selectParticipantIds.length > 0 ? selectParticipantIds.join(this._delimiter) : '',

                    allday: this.allDay
                };
                if (this.locationExpand) {
                    formData['locationExpand'] = JSON.stringify(this.locationExpand);
                }

                if (this.invliadContactList.length > 0) {
                    formData['nonContactParticipants'] = JSON.stringify(this.invliadContactList);
                }

                formData['pretreatment-file'] = files;
                this._savingNote = true;
                const params = this._templateService.buildEntryTemplateParamsForWeb(valueSet, this._noteTypeId, this._noteAction, this.editingEntryId, false);
                params.showattachmentsbyentry = true;
                // Use Graph API to indicate deposited events
                if (this._noteAction === NoteActions.createNote) {
                    if (AddInUtilities.isOfficeEnvironment()) {
                        if (Office.context.host.toString() === AddInType.OUTLOOK) {
                            const itemId = Office.context.mailbox.item.itemId;
                            const type = this._dialogOpenOptions.triggerSource === CalendarDialogTriggerSource.NoteDialog ? MailBoxItemType.Message : MailBoxItemType.Event;
                            params['originInfo'] = {
                                source: MailBoxItemSource.Addin,
                                type: type,
                                itemId: itemId,
                                itemOwnerEmailAdd: Office.context.mailbox.userProfile.emailAddress
                            };
                        }
                    }
                }
                let updateThreadEntity;
                if (this._saveAction !== NoteActions.saveDraft) {
                    updateThreadEntity = this._updateThreadEntity();
                }
                // server required format for attaching files to current note.
                switch (this._noteAction) {
                    case NoteActions.createNote:
                        if (this.editingEntryId) {
                            this._noteTemplatePageViewModel.updateNote(this.editingEntryId, params, formData, draftFlag, auto, updateThreadEntity);
                        } else {
                            this._noteTemplatePageViewModel.createNote(params, formData, draftFlag, auto, updateThreadEntity);
                        }
                        break;
                    case NoteActions.editNote:
                        this._noteTemplatePageViewModel.updateNote(this.editingEntryId, params, formData, draftFlag, auto, updateThreadEntity);
                        break;
                    default:
                        break;
                }
            }
        };
        this.noteAttachmentsConfig.actionSubject$.next(action);
    }

    private _setPluginEventEditPageStyle() {
        if (this._el.querySelector('.calendar-dialog')) {
            this._renderer.addClass(this._el.querySelector('.calendar-dialog'), 'calendar_dialog_container');
        }
    }

    /**
     * only for web plugin
     * the value of 'hidden-note-dialog' should be 20px after click save/close/save draft button
     */
    private _setDialogCloseForPlugin() {
        if (this.isPlugInEditNoteMode) {
            this.isDialogClosedForPlugin = 20;
        }
    }

    private _setCusor() {
        setTimeout(() => {
            if (this.locationEl && this.isShowEventArea && this._noteAction !== NoteActions.createSidenote) {
                this.locationEl.nativeElement.focus();
            }
        });
    }

    /**
  * get all addin data and load attachments.
  * @param res
  */
    private _showAddInInfoOnNoteDialog(res) {
        const self = this;
        this._onAttachmentLoaded(res, false, true, true);
        this._currentAttachemtId = UUID.UUID();
        this._officeAddIn.uuid = this._currentAttachemtId;
        // clear attachments
        this._officeAddIn.attachments = [];
        this.attachmentUploading = true;
        // Some parts of the code runs out of the Angular zone, so add zone to update UI.
        this._destroySubscriptions.push(this._noteDialogService.getAllDataForAddIn(this._officeAddIn).subscribe(result => {
            if (result) {
                self._officeAddIn = result;
                if (self._firstOpen) {
                    self._officeAddInOld = _lodash.cloneDeep(result);
                }
                self._zone.run(() => {
                    self._processNoteTemplateConfiguration(res);
                });
            }
        }));

        switch (Office.context.host.toString()) {
            case AddInType.OUTLOOK:
                const officeMailboxItem = Office.context.mailbox.item;
                // When user clicks the 'Email only' icon, deposit the email into Tamale without attachment.
                if (AddInGlobalModel.currentAddInDepositType !== AddInDepositType.ADDINONLYFILE) {
                    // set email as an attachment
                    this._destroySubscriptions.push(
                        this._noteDialogService.getEmailContentForAddIn(this._officeAddIn, this._setAttachmentProgressStatus.bind(this)).subscribe(() => {
                        }));
                }

                // When user clicks the 'File(s) only' icon, deposit the email into Tamale without email content file.
                if (AddInGlobalModel.currentAddInDepositType !== AddInDepositType.ADDINONLYEMAIL) {
                    // handle attachments of email
                    const fileArray = officeMailboxItem.attachments.filter(attachment => !attachment.isInline);
                    if (fileArray.length === 0 && AddInGlobalModel.currentAddInDepositType === AddInDepositType.ADDINONLYFILE) {
                        this.attachmentUploading = false;
                        this._onAttachmentLoaded(null, false, true);
                    }
                    fileArray.forEach(att => {
                        this._destroySubscriptions.push(
                            this._noteDialogService.getEmailAttachmentsForAddIn(att, this._officeAddIn, this._setAttachmentProgressStatus.bind(this)).subscribe(() => {
                            }));
                    });
                }
                break;
        }
    }


    /**
     * callback attachment status and set progressbar.
     * @param res officeAddin data
     */
    private _setAttachmentProgressStatus(res) {
        if (res.uuid === this._currentAttachemtId) {
            if (res.attachments) {
                this.attachmentUploading = res.attachments.findIndex(item => item.progress !== '100%') > -1;
                this._changeDetectorRef.detectChanges();
            }
            this._onAttachmentLoaded(res, false, true);
        }
    }

    /**
     * _takePrivacyConfiguration returns privacy enabled and privacySetting. if privacy isn't enabled, no more actions next.
     * @param configData. Formats:
     * {"privacySetting":"personal team",
     * "privacyEnabled":true,
     * "relationshipBasedDefaultingEnable":true,
     * "personTeamRelationshipTypeID":"21323ffe7f00001049f512df003f7c9e",
     * "primaryTeamRelationshipTypeID":"821dde770a16aed096cc99ec4f1a6df4"}
     */
    private _takePrivacyConfiguration(configData: any): any {
        if (configData !== null && configData !== undefined) {
            if (configData.privacyEnabled === true) {
                this.privacyEnabled = true;
                this._noteTemplatePageViewModel.getPrivacyTeams(configData);
                this.isPrivacy = true;
            } else {
                this.privacyEnabled = false;
                this.isPrivacy = false;
            }
        }
    }

    /**
     * _takePrivacyTeams sets the _privacyListConfig for privacy list usage.
     * @param privacyTeams
     */
    private _takePrivacyTeams(payload: any) {
        if (payload !== null && payload !== undefined) {
            this._privacyList = payload.privacyTeams;
            this._privacyListSource = this._privacyList;
            this.privacyListDefalult = payload.privacySelectedTeam;
            if (payload.privacySelectedTeam && payload.privacySelectedTeam.id) {
                this._privacyTeam = payload.privacySelectedTeam;
            }
        }
    }

    private _takeNoteBodyForEdit(noteBody) {
        if (noteBody && noteBody.body && noteBody.body.length > 0) {
            this._noteBodyHtml = noteBody.body;
            this._noteBodySubject.next({
                type: SET_NOTE_BODY_FOR_EDITING,
                payload: this._noteBodyHtml
            });
        }
    }

    private _takeTemplateMsg(msg) {
        let toastMsg;
        if (msg === CREATE_EVENT_SUCCESS || msg === UPDATE_EVENT_SUCCESS) {

            this._clearData();
            this.close();
            if (this._noteAction === NoteActions.createNote) {
                toastMsg = this._saveAction === NoteActions.saveNote ? 'Event successfully created.' : 'Draft successfully created.';
                this._infoToast.style = NotificationStyles.Success;
                if (AddInUtilities.isOfficeEnvironment()) {
                    // the entry created has been saved to store, we need to retrieve and show the entry link to user
                    const noteState = this._storeQuerier.queryBySelector(getNoteSelector);
                    if (noteState) {
                        this._addinEntryId = noteState.entry.id;
                        this.addinSubject = noteState.entry.calculatedTitle;
                        this.addinSuccessTip = this.editingEntryId ? StringLiteralsPipe.translate('addin.event_successfully_updated') : StringLiteralsPipe.translate('addin.event_successfully_created');
                    }
                    this.isDialogHidden = true;
                }
            } else if (this._noteAction === NoteActions.editNote) {
                toastMsg = this._saveAction === NoteActions.saveNote ? 'Event successfully updated.' : 'Draft successfully updated.';
                this._setDialogCloseForPlugin();
                this._infoToast.style = NotificationStyles.Success;

            }
            this._noteTemplatePageViewModel.cleanTemplateMsg();
            if (this._saveAction !== NoteActions.saveDraft) {
                const relationshipArray = this._templateService.relationshipSaveAction(this._templateValueSet, null);
                if (relationshipArray && relationshipArray.length > 0) {
                    this._noteTemplatePageViewModel.createRelationships(relationshipArray);
                }
            }
            // add a time out because if delete a note through note option menu,
            // wait for the page navigation is done, then show toast on the previous page
            this._infoToast.message = toastMsg;

            setTimeout(() => {
                if (!this.isOfficeAddinMode) {
                    this._toast.notify(this._infoToast);
                }
            }, AppConfig.subPageTransitionDuration);
            this._noteTemplatePageViewModel.cleanTemplateMsg();
        } else if (msg.indexOf(CREATE_EVENT_FAILURE) === 0 || msg.indexOf(UPDATE_EVENT_FAILURE) === 0) {
            if (this._noteAction === NoteActions.createNote) {
                toastMsg = 'Event could not be created.Please try again.';
            } else if (this._noteAction === NoteActions.editNote) {
                toastMsg = 'Event could note be updated.';
            }
            this._savingNote = false;
            this._infoToast.message = toastMsg;
            this._infoToast.style = NotificationStyles.Error;
            this._toast.notify(this._infoToast);
            this._noteTemplatePageViewModel.cleanTemplateMsg();
            this.publishButtonHasBeenClicked = false;
        }
    }

    private _takeNoteType(res: any) {
        if (res == null) {
            return;
        }
        if (res.entryTypes && res.entryTypes.length > 0) {
            this._noteTypesSource = res.entryTypes.filter(item => item.usage && item.usage.indexOf(businessConstants.EntryTypes.event) > -1);
            this._noteTypes = this._noteTypesSource.slice();
        }
        if (this._createEntryId) {
            this._noteTypeId = this._createEntryId;
        } else {
            if (res.defaultEntryTypeId && res.defaultEntryTypeId.length > 0) {
                this._noteTypeId = res.defaultEntryTypeId;
            }
        }
        if (this.opened) {
            this._initDefaultNoteType(res);
        }
    }

    private _updateThreadEntity(): { parentNoteId: string, entityIds: Array<string> } {
        const result: { parentNoteId: string, entityIds: Array<string> } = {
            parentNoteId: null,
            entityIds: null,
        };
        if ((this._noteAction === NoteActions.createSidenote || this._noteAction === NoteActions.editSidenote) &&
            this._newEntitiesFieldValue.length > 0) {
            result.parentNoteId = this._entry.threadId;
            result.entityIds = this._newEntitiesFieldValue;
            return result;
        } else {
            return null;
        }
    }

    private _validateEntityChangesForSidenote(valueSet, dratFlag: boolean, auto: boolean = false) {
        const originEntitiesField = ArrayHelperService.uniqueArray(_lodash.cloneDeep(this._entry[StandardControlIds.entity.toLowerCase()])).sort().toString();
        const newEntitiesField = ArrayHelperService.uniqueArray(valueSet[StandardControlIds.entity].value.split(';')).sort().toString();
        if ((newEntitiesField !== originEntitiesField)
            && ((this._entry.totalNotesInThread > 1 && this._noteAction === NoteActions.editNote)
                || (this._noteAction === NoteActions.createSidenote)
                || (this._noteAction === NoteActions.editSidenote))) {
            const arrayMsg: string[] = [];
            if (this._entry.totalNotesInThread === 1) {
                arrayMsg.push('1 note is part of this thread.');
            } else if (this._entry.totalNotesInThread === 2) {
                arrayMsg.push('1 note and 1 sidenote are part of this thread.');
            } else if (this._entry.totalNotesInThread > 2) {
                arrayMsg.push('1 note and ' + (this._entry.totalNotesInThread - 1) + ' sidenotes are part of this thread.');
            }
            arrayMsg.push('\nAre you sure you want to change the entities on all items in this thread?');
            const subscription = this._alertWindow.warn('Confirmation', arrayMsg, 'Change').subscribe((result: boolean) => {
                if (result) {
                    this._newEntitiesFieldValue = newEntitiesField.split(',');
                    this._saveNote(valueSet, dratFlag, auto);
                } else {
                    this.publishButtonHasBeenClicked = false;
                }
                subscription.unsubscribe();
            });
        } else {
            this._saveNote(valueSet, dratFlag, auto);
        }
    }
}


